import { render, staticRenderFns } from "./Accomodation.vue?vue&type=template&id=752d8b88&"
import script from "./Accomodation.vue?vue&type=script&lang=js&"
export * from "./Accomodation.vue?vue&type=script&lang=js&"
import style0 from "./Accomodation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports